import React, { useState, useEffect } from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { Card, CardBody, CardHeader, Label } from "reactstrap";
import {format } from 'date-fns'

const COLORS = ["#2B5F60", "#A3A3A8"]; // Colors for the progress and background

const LoadingChart = () => {

    const progress = 80;
    const formatted = format(new Date(), "dd-MM-yyyy HH:mm:ss");

    return (
        <Card className="m-0 b-r-0">
            <CardHeader>
                <div className="d-flex justify-content-between">
                <h5 style={{ fontWeight: "600" }}>Pumping Time</h5>
                 <span>{formatted}</span>

                </div>
            </CardHeader>
            <CardBody >
                <ResponsiveContainer width="100%" height={300}>
                    <PieChart>
                        <Tooltip />
                        <Pie
                            data={[
                                { name: "Progress", value: progress },
                                { name: "Remaining", value: 100 - progress },
                            ]}
                            cx="50%"
                            cy="60%" // Position at the bottom to create a semi-circle
                            innerRadius={60}
                            outerRadius={100}
                            //fill="#8884d8"
                            dataKey="value"
                            startAngle={180} // Start from the left
                            endAngle={0} // End at the right (completing the half-circle)
                        >
                            {/* Coloring the segments */}
                            <Cell key="progress" fill={COLORS[0]} />
                            <Cell key="remaining" fill={COLORS[1]} />



                        </Pie>
                    </PieChart>
                </ResponsiveContainer>
                <div
                    style={{
                        position: "absolute",
                        top: "60%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontWeight: "bold",
                        fontSize: "20px",
                        color: "#333",
                    }}
                >
                    {progress}%
                </div>
            </CardBody>
        </Card>
    );
};

export default LoadingChart;
